<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznisilanlari from "@/models/mznisilanlari";
import Banner from "../components/banner";
import forminput from "@/router/views/formcomponet/forminput.vue"; 
import formcombobox from "../formcomponet/formcombobox.vue";
import Drawer from "vue-simple-drawer";
import Eye from "./eye.vue";
import moment from "moment";

export default {
  mixins: [apibtoast, apigeneric, mznisilanlari], 
  props: {
    WebSiteConfig: [String, Object],
  },
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    forminput,
    Drawer,
    formcombobox,
    Eye
  },
  data() {
    return {
      UserTur:null,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FirmaData: {},
      TableData: [],
      DataUpdate: "",
      Filter: {
        Firmaadi: "",
        Calismasekli: "",
        Istipi:"",
        Cinsiyet: "",
        Ehliyet: "",
        Egitimseviyesi: "",
        Askerlikdurumu: ""
      },
      FilitrelemePenceresi: false,
    };
  },
  validations: {
    Filter: {
      Firmaadi: {},
      Calismasekli: {},
      Istipi:{},
      Cinsiyet: {},
      Ehliyet: {},
      Egitimseviyesi: {},
      Askerlikdurumu: {},



    },
  },
  methods: {
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    Get() {
      let Filter =
        "&Firmaadi=" +
        this.Filter.Firmaadi +
        "&Calismasekli=" +
        this.Filter.Calismasekli +
        "&Istipi=" +
        this.Filter.Istipi +
        "&Ehliyet=" +
        this.Filter.Ehliyet +
        "&Askerlikdurumu=" +
        this.Filter.Askerlikdurumu+
        "&Egitimseviyesi=" +
        this.Filter.Egitimseviyesi ;
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznisilanlari",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.Page.PageDataSize = res.TotalCount;
        this.TableData = [];
        for(var Data in res.Data){
          if(res.Data[Data].Sonbasvurutarihi != null){
          var tarih1 = moment(String(res.Data[Data].Sonbasvurutarihi)).format("YYYY-MM-DD");
          var tarih2 = moment(new Date()).format("YYYY-MM-DD")
          var tarih3 = moment(String(res.Data[Data].Yayinlanmatarihi)).format("YYYY-MM-DD");
              if(tarih2 <= tarih1){
                if(tarih3 <= tarih2){
                  this.TableData.push(res.Data[Data])
                }
              }                       
          }
        }
      });


 
                this.ActionsFilterGet({
                  Service: this.$config.API_URL_2 + "mznfirma",
                  Page: this.Page,
                  Filter: "&Userid=" + this.TokenUserId,
                }).then((responsefirma) => {
                  if (responsefirma.Data.length > 0) {
                    this.UserTur= 'Firma'
                    this.FirmaData = responsefirma.Data
                  }else{
                    this.UserTur= 'Mezun'
                  }
                });
          
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />
      <div class="graduates"> 
        <div class="container">
          <div class="row"> 
                <div class="col-sm-12">
                  <div class="text-sm-end">
                         
              <router-link v-if="UserTur == 'Firma'" tag="span" to="/mznisilanlarifirma" role="button" class="btn btn-info mx-3">
              <i class="bx bx-user-plus font-size-16 align-middle me-1 text-danger"></i>
              {{ $t("mznisilanlari.Page.Isilanlari") }}
            </router-link>
                  </div>
                  </div>
                  </div>
          <div class="table-graduate">
            <p class="h2 text-center cl-service-dark">İş İlanları</p>
            <div class="container">
              <div class="search-bar" v-if="this.UserTur == 'Mezun'">
                <div class="row c-flex">
                  <div class="col-md-3 l-flex">
                    <div class="form-group full-width">
                      <input
                        v-model="Filter.Firmaadi"
                        type="name"
                        name="name"
                        class="form-control"
                        placeholder="Firma Adı"
                      />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex" style = "top:7px;">
                    <div class="form-group full-width" >
                      <formcombobox
                      :FormDataType="{
                        FieldName: 'Iş Tipi',
                        Field: 'input',
                        ComboDataArray: FormDataType.Egitimseviyesi.ComboDataArray,
                      }"
                      :Value="Filter.Egitimseviyesi"
                      :v="$v.Filter.Egitimseviyesi"
                      @input="Filter.Egitimseviyesi = $event"
                    />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex" style = "top:7px;">
                    <div class="form-group full-width" >
                      <formcombobox
                      :FormDataType="{
                        FieldName: 'Iş Tipi',
                        Field: 'input',
                        ComboDataArray: FormDataType.Istipi.ComboDataArray,
                      }"
                      :Value="Filter.Istipi"
                      :v="$v.Filter.Istipi"
                      @input="Filter.Istipi = $event"
                    />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex" style = "top:7px;">
                    <div class="form-group full-width">
                      <formcombobox
                      :FormDataType="{
                        FieldName: 'Calismasekli',
                        Field: 'input',
                        ComboDataArray: FormDataType.Calismasekli.ComboDataArray,
                      }"
                      :Value="Filter.Calismasekli"
                      :v="$v.Filter.Calismasekli"
                      @input="Filter.Calismasekli = $event"
                    />
                    </div>
                  </div>
                  <div class="col-md-1">
                  
                    <b-button
                      type="button "
                      @click="Get()"
                      class="btn btn-dark full-width"
                    >
                      Ara
                    </b-button>
                    </div>
                    <div class="col-md-2 l-flex " v-if="this.UserTur == 'Mezun'">
                    <b-button v-if="WebSiteConfig.Isilanlarigelismisfiltreleme"
                      type="button"
                      class="btn btn-secondary btn-rounded full-width"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search"></i>
                      {{ $t("mznisilanlari.Page.GelismisFiltreleme") }}
                    </b-button>
                  
                  </div>
                </div>
              </div>

              <ul class="table-main">
                <li class="head bg-service">
                  <div class="row">
                    <div class="col-md-2  l-flex">
                      <span class="order">{{
                        $t("mznisilanlari.Table.Firmaadi")
                      }}</span>
                    </div>
                    <div class="col-md-2  l-flex">
                      <span>{{ $t("mznisilanlari.Table.Istipi") }}</span>
                    </div>
                    <div class="col-md-3  l-flex">
                      <span>{{ $t("mznisilanlari.Table.Pozisyon") }}</span>
                    </div>
                    <div class="col-md-3  l-flex">
                      <span>{{ $t("mznisilanlari.Table.Egitimseviyesi") }}</span>
                    </div>
                    <div class="col-md-2 l-flex">
                      <span>{{ $t("mznmezunlar.Table.Detay") }}</span>
                    </div>
                  </div>
                </li>
                <div v-for="(Data, index) in TableData" :key="index" >
                <li v-if="Data.Onay">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 l-flex">
                        <span class="order">{{ Data.Firmaadi }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span class="profil-image">
                          {{ Data.Istipivalue }}
                        </span>
                      </div>
                      <div class="col-md-3 l-flex">
                        <span class="student-name">{{ Data.Pozisyon }}</span>
                      </div>
                      <div class="col-md-3 l-flex">
                        <span>{{ Data.Egitimseviyesivalue }}</span>
                      </div>
                      <div class="col-md-2 l-flex ">
                       <b-button variant="primary" v-b-modal.eye @click="(DataUpdate = Data)"><i
                              class="far fa-eye "></i></b-button>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
              </ul>

              <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
      <Eye :Id="DataUpdate"/>
 <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("mznmezunlar.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("mznmezunlar.Filtreleme.Content") }}
            <div class="mb-3 mt-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Firma Adı',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Firmaadi'),
                }"
                :Value="Filter.Firmaadi"
                :v="$v.Filter.Firmaadi"
                @input="Filter.Firmaadi = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Iş Tipi',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Istipi'),
                  ComboDataArray: FormDataType.Istipi.ComboDataArray,
                }"
                :Value="Filter.Istipi"
                :v="$v.Filter.Istipi"
                @input="Filter.Istipi = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Çalışma Şekli',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Calismasekli'),
                  ComboDataArray: FormDataType.Calismasekli.ComboDataArray,
                }"
                :Value="Filter.Calismasekli"
                :v="$v.Filter.Calismasekli"
                @input="Filter.Calismasekli = $event"
              />
            </div>
     <!--      <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Cinsiyet',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Cinsiyet'),
                  ComboDataArray: FormDataType.Cinsiyet.ComboDataArray,
                }"
                :Value="Filter.Cinsiyet"
                :v="$v.Filter.Cinsiyet"
                @input="Filter.Cinsiyet = $event"
              />
            </div> --> 
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Ehliyet',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Ehliyet'),
                  ComboDataArray: FormDataType.Ehliyet.ComboDataArray,
                }"
                :Value="Filter.Ehliyet"
                :v="$v.Filter.Ehliyet"
                @input="Filter.Ehliyet = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Askerlik Durumu',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Askerlikdurumu'),
                  ComboDataArray: FormDataType.Askerlikdurumu.ComboDataArray,
                }"
                :Value="Filter.Askerlikdurumu"
                :v="$v.Filter.Askerlikdurumu"
                @input="Filter.Askerlikdurumu = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Egitim Seviyesi',
                  Field: 'input',
                  FieldTitle: $t('mznisilanlari.Filtreleme.Egitimseviyesi'),
                  ComboDataArray: FormDataType.Egitimseviyesi.ComboDataArray,
                }"
                :Value="Filter.Egitimseviyesi"
                :v="$v.Filter.Egitimseviyesi"
                @input="Filter.Egitimseviyesi = $event"
              />
            </div>
          

            <b-button
              @click="Get()"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("mznmezunlar.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>



    </Layout>
  </Loader>
</template>
